// Object assign polyfill
require('./bootstrap');
require('./mixins');
require('./directives');
require('./components');

import Vue from 'vue';
import store from './store';
import router from './routes.js';
import PortalVue from 'portal-vue';
import http from './http';
import * as Sentry from "@sentry/vue";

Vue.use(PortalVue);

Sentry.init({
  Vue,
  dsn: "https://1972b535f27d4f449fd8122ab7c4d1ae@o1374453.ingest.sentry.io/4505246483152896",
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  ignoreErrors: [
    /Avoided redundant navigation to current location.*/
  ],
});

// Clear notifications on route change
router.beforeEach((to, from, next) => {
  store.dispatch('notifications/clear');

  next();
});

// if (window.IS_CORDOVA) {
//   router.beforeEach((to, from, next) => {
//     if (to.meta?.cordova_new_window) {
//       navigator.notification.alert(
//         'You are about to be redirected to the website where you will be able to manage your subscriptions',
//         function () {
//           cordova.InAppBrowser.open('https://foodfitnessfirst.com' + to.fullPath, '_system');
//
//           next('/');
//         },
//         'Redirecting...',
//       );
//     } else {
//       next();
//     }
//   });
// }

router.afterEach((to, from, failure) => {
  if (failure) {
    return;
  }

  try {
    gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: to.fullPath,
    });
  } catch (e) {
    console.error(e);
  }

});

router.beforeEach((to, from, next) => {
  try {
    $('#navBar').collapse('hide');
  } catch (e) {
    console.error(e);
  } finally {
    next();
  }
});

// Attempt to load user session
store.dispatch('user/init').catch((err) => {});

Vue.prototype.$recaptchaKey = process.env.MIX_GOOGLE_RECAPTCHA_KEY;
Vue.prototype.$isCordova = window.IS_CORDOVA;

Vue.prototype.$http = http;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
new Vue({
  el: '#app',
  router,
  store
});
